import React, { FC, createContext, useEffect } from "react";
import { FormProvider } from "rc-field-form";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./shared/i18n";
import { BrowserRouter } from "react-router-dom";
import { AppConfig } from "./config";
import { ValidateMessages } from "rc-field-form/es/interface";
import dinero, { Currency } from "dinero.js";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "./store/endpoints";
import { $currentLocale } from "./store/shared/locales";

const Providers: FC = ({ children }) => {
  const { data: settings } = useStore(SettingsEndpoint.store);
  const currentLocale = useStore($currentLocale);

  return (
    <I18nextProvider i18n={i18n}>
      <FormValidationMessagesProvider>
        <ProvideMoney
          locale={currentLocale.dinero}
          currency={settings?.currency}
        >
          <BrowserRouter basename={AppConfig.publicUrl}>
            {children}
          </BrowserRouter>
        </ProvideMoney>
      </FormValidationMessagesProvider>
    </I18nextProvider>
  );
};

export default Providers;

const FormValidationMessagesProvider: FC = ({ children }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.ff);

  const validateMessages: ValidateMessages = {
    default: t("errs.default"),
    required: t("errs.required"),
    // enum: t("errs.default"),
    // whitespace: t("errs.default"),
    date: {
      format: t("errs.default"),
      parse: t("errs.default"),
      invalid: t("errs.default"),
    },
    types: {
      // string: t("errs.default"),
      // method: t("errs.default"),
      // array: t("errs.default"),
      // object: t("errs.default"),
      // number: t("errs.default"),
      // date: t("errs.default"),
      // boolean: t("errs.default"),
      // integer: t("errs.default"),
      // float: t("errs.default"),
      // regexp: t("errs.default"),
      email: t("errs.invalid"),
      // url: t("errs.default"),
      // hex: t("errs.default"),
    },
    // string: {
    //   len: t("errs.default"),
    //   min: t("errs.default"),
    //   max: t("errs.default"),
    //   range: t("errs.default"),
    // },
    // number: {
    //   len: t("errs.default"),
    //   min: t("errs.default"),
    //   max: t("errs.default"),
    //   range: t("errs.default"),
    // },
    // array: {
    //   len: t("errs.default"),
    //   min: t("errs.default"),
    //   max: t("errs.default"),
    //   range: t("errs.default"),
    // },
    pattern: {
      mismatch: t("errs.invalid"),
    },
  };

  return (
    <FormProvider validateMessages={validateMessages}>{children}</FormProvider>
  );
};

type MoneyStore = { currency?: Currency; locale: string };
export const MoneyContext = createContext<MoneyStore>({
  locale: AppConfig.locales[0].dinero,
});
const ProvideMoney: FC<MoneyStore> = ({ children, ...value }) => {
  useEffect(() => {
    dinero.defaultCurrency = value.currency ?? "USD";
  }, [value]);

  return (
    <MoneyContext.Provider value={value}>{children}</MoneyContext.Provider>
  );
};
